/**
 * Returns instance of Date which holds date when a cookie should expire.
 *
 * @param type
 * @returns Date of expiry
 */
const getCookieExpires = (type) => {
    switch (type) {
        case 'cookie-consents': {
            const expirationDate = new Date();
            expirationDate.setFullYear(expirationDate.getFullYear() + 2);
            return expirationDate;
        }
        case 'session-uid': {
            const thirtyMinInMillis = 30 * 60 * 1000;
            const expirationDate = new Date();
            expirationDate.setTime(expirationDate.getTime() + thirtyMinInMillis);
            return expirationDate;
        }
        case 'wolt-uid': {
            const now = new Date();
            const tenYearsFromNow = new Date(now.getFullYear() + 10, now.getMonth());
            return tenYearsFromNow;
        }
        case 'device-fingerprint': {
            const now = new Date();
            const sixtyDaysFromNow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 60);
            return sixtyDaysFromNow;
        }
        case 'wfw-register': {
            const now = new Date();
            const oneDayfromNow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
            return oneDayfromNow;
        }
        case 'utm-params': {
            const expirationDate = new Date();
            expirationDate.setMonth(expirationDate.getMonth() + 1);
            return expirationDate;
        }
        default:
            return undefined;
    }
};
/**
 * Returns all options for the cookie. Use this function
 * to correctly set up any shared cookie.
 *
 * @param domain base domain for the cookie
 * @returns cookie options
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie#attributes
 */
function getCookieOptions(type, domain) {
    return {
        expires: getCookieExpires(type),
        domain,
        path: '/',
        secure: true,
        httpOnly: undefined,
    };
}
export { getCookieOptions };
